import {SwiperGamesListDefaultBox} from './swiper-games-list.default.box';

export const SwiperGamesListBox = SwiperGamesListDefaultBox;